var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ParcelaImovel } from '../../../../../model/ParcelaImovel';
import { TipoImovelEnum } from '../../../../../model/enums/TipoImovelEnum';
import { ModoCRUDEnum } from '../../../../../model/enums/ModoCRUDEnum';
import { hasErrors, hasValue } from '../../../../utils/ValidationUtils';
import { prettyArea } from '../DadosImovelUsucapiaoRural';
import { useCacheStore } from '../../../../../stores/CacheStore';
import { DocumentoAquisicaoEnum } from '../../../../../model/enums/DocumentoAquisicaoEnum';
import { generateErrorFields, handleScrollTop, useRequerimentoContext, } from '../../context/RequerimentoContext';
import { DefaultCard } from '../../../../../components/DefaultCard';
import { SimpleTable } from '../../../../../components/SimpleTable/SimpleTable';
import { AuthConstants } from '../../../../../util/auth-constants';
import { TipoParcelaEnum } from '../../../../../components/TipoParcelaEnum';
import { DadosPecasTecParcela } from '../../../../../components/DadosPecasTecParcela';
import { SessaoSIGEF } from '../../../../../components/SessaoSIGEF';
import { CustomRadioGroup } from '../../../../../components/Forms/CustomRadioGroup';
import ParcelaFormSigef from '../../common/ParcelaFormSigef';
import { ParcelaImovelCadastro } from '../../common/ParcelaImovelCadastro';
import ParcelaFormSNCI from '../../common/ParcelaFormSNCI';
import { StepContent } from '../EmpreendimentoRural/StepContent';
import { CommonUtils, validateRtFields } from '../../../../../util/CommonUtils';
import { ShowContent } from '../../../../../components/ShowContent';
export var documentoMap = {
    titulo: DocumentoAquisicaoEnum.CONTRATO_PART_COMPRA_VENDA,
    matricula: DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE,
    escritura: DocumentoAquisicaoEnum.DECLARACAO_OCUPACAO,
};
export var reverseDocumentoMap = (_a = {},
    _a[DocumentoAquisicaoEnum.CONTRATO_PART_COMPRA_VENDA] = 'titulo',
    _a[DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE] = 'matricula',
    _a[DocumentoAquisicaoEnum.DECLARACAO_OCUPACAO] = 'escritura',
    _a[DocumentoAquisicaoEnum.OUTROS] = 'titulo',
    _a);
export var reverseDocumentoMapPretty = (_b = {},
    _b[DocumentoAquisicaoEnum.CONTRATO_PART_COMPRA_VENDA] = 'Título',
    _b[DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE] = 'Matricula',
    _b[DocumentoAquisicaoEnum.DECLARACAO_OCUPACAO] = 'Escritura',
    _b[DocumentoAquisicaoEnum.OUTROS] = 'Título',
    _b);
export var SolicitarEstudoCadastral = function (_a) {
    //region Constants
    var _b, _c, _d, _e, _f, _g, _h;
    var requerimentoFieldErrorChange = _a.requerimentoFieldErrorChange, requerimentoFieldError = _a.requerimentoFieldError, ocultarCampo = _a.ocultarCampo, requerimento = _a.requerimento, onValidate = _a.onValidate, onChange = _a.onChange;
    var isImovelRural = true;
    var defaultParcela = __assign(__assign({}, new ParcelaImovel()), { municipioOrigem: undefined, municipio: undefined, responsavelTecnico: undefined, quadra: undefined, lote: undefined, livroFundiario: undefined, folhaLivroFundiario: undefined, orgaoResponsavel: undefined, pecasTecnicas: TipoParcelaEnum.SIGEF });
    var _j = useRequerimentoContext(), defaultHandleAddParcelaImovel = _j.defaultHandleAddParcelaImovel, getStatusSigef = _j.getStatusSigef;
    var _k = useState(null), indexSelecionadoTeor = _k[0], setIndexSelecionadoTeor = _k[1];
    var _l = useState(TipoParcelaEnum.SIGEF), pecasTecnicas = _l[0], setPecasTecnicas = _l[1];
    var _m = useState(new ParcelaImovel()), parcelaImovel = _m[0], setParcelaImovel = _m[1];
    var _o = useState(false), isDisabledBySigef = _o[0], setIsDisabledBySigef = _o[1];
    var _p = useState(false), sigefIsOnline = _p[0], setSigefIsOnline = _p[1];
    var _q = useState(false), editarIncluir = _q[0], setEditarIncluir = _q[1];
    var _r = useState(false), possuiRtSigef = _r[0], setPossuiRtSigef = _r[1];
    var _s = useState(ModoCRUDEnum.CREATE), modo = _s[0], setModo = _s[1];
    var _t = useState([]), columns = _t[0], setColumns = _t[1];
    var _u = useState({}), fieldError = _u[0], setFieldError = _u[1];
    //endregion
    //region Hooks
    var documentoSelecionado = useMemo(function () {
        var _a;
        var docAquisicao = (_a = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.documentoAquisicao) !== null && _a !== void 0 ? _a : DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE;
        return reverseDocumentoMap[docAquisicao];
    }, [parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.documentoAquisicao]);
    var pecasIsSigef = useMemo(function () {
        return pecasTecnicas === TipoParcelaEnum.SIGEF;
    }, [pecasTecnicas]);
    var isEdit = useMemo(function () {
        return modo === ModoCRUDEnum.UPDATE;
    }, [modo]);
    useEffect(function () {
        setColumns((pecasTecnicas === TipoParcelaEnum.SNCI
            ? [
                { label: ' Número da certidão', value: 'numeroCertificacao' },
                { label: 'Denominação da Parcela', value: 'denominacao' },
                { label: 'Área(ha)', value: 'area' },
                { label: 'Município', value: 'municipio' },
            ]
            : [
                { label: 'Código SIGEF da Parcela', value: 'codigoSIGEF' },
                { label: 'Denominação da Parcela', value: 'denominacao' },
                { label: 'Área(ha)', value: 'area' },
                { label: 'Município', value: 'municipio' },
                { label: 'Status SIGEF', value: 'statusSIGEF' },
            ]).filter(Boolean));
    }, [pecasTecnicas, documentoSelecionado, sigefIsOnline]);
    useEffect(function () {
        handleInitialize();
    }, []);
    useEffect(function () {
        var cacheStore = useCacheStore.getState();
        cacheStore.setCache(AuthConstants.PARCELA_IMOVEL_CACHE, __assign(__assign({}, parcelaImovel), { requerimentoId: requerimento === null || requerimento === void 0 ? void 0 : requerimento.id }));
    }, [parcelaImovel, requerimento === null || requerimento === void 0 ? void 0 : requerimento.id]);
    useEffect(function () {
        if (onValidate) {
            onValidate(handleValidate);
        }
    }, [(_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _b === void 0 ? void 0 : _b.length, fieldError]);
    var cpfRequerente = useMemo(function () {
        return CommonUtils.cpfRequerente(requerimento);
    }, [requerimento]);
    var cnpjRequerente = useMemo(function () {
        return CommonUtils.cnpjRequerente(requerimento);
    }, [requerimento]);
    var values = useMemo(function () {
        var _a;
        if (!((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        return requerimento.parcelasImovel.map(function (parcela) {
            var _a, _b, _c, _d, _e, _f;
            var areaFormatada = (_a = prettyArea(parcela === null || parcela === void 0 ? void 0 : parcela.area)) !== null && _a !== void 0 ? _a : '';
            var municipio = (_c = (_b = parcela === null || parcela === void 0 ? void 0 : parcela.municipio) === null || _b === void 0 ? void 0 : _b.nome) !== null && _c !== void 0 ? _c : '';
            var denominacao = (_d = parcela === null || parcela === void 0 ? void 0 : parcela.denominacao) !== null && _d !== void 0 ? _d : '';
            if (pecasTecnicas === TipoParcelaEnum.SNCI) {
                return {
                    numeroCertificacao: (_e = parcela === null || parcela === void 0 ? void 0 : parcela.numeroCertificacao) !== null && _e !== void 0 ? _e : '',
                    denominacao: denominacao,
                    area: areaFormatada,
                    municipio: municipio,
                };
            }
            return {
                codigoSIGEF: (_f = parcela === null || parcela === void 0 ? void 0 : parcela.codigoSIGEF) !== null && _f !== void 0 ? _f : '',
                denominacao: denominacao,
                area: areaFormatada,
                municipio: municipio,
                statusSIGEF: getStatusSigef(parcela, sigefIsOnline),
            };
        });
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel, pecasTecnicas, sigefIsOnline, getStatusSigef]);
    var subTitle = useMemo(function () {
        if (pecasTecnicas === TipoParcelaEnum.SNCI) {
            return 'Informe a(s) parcela(s) do imóvel Rural no SNCI';
        }
        return 'Informe a(s) parcela(s) do imóvel Rural em peças técnicas SIGEF';
    }, [pecasTecnicas]);
    var handleValidate = useCallback(function () {
        var _a;
        var isEmpty = !((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length);
        requerimentoFieldErrorChange === null || requerimentoFieldErrorChange === void 0 ? void 0 : requerimentoFieldErrorChange(__assign(__assign({}, requerimentoFieldError), { parcelasImovelError: isEmpty ? 'Ao menos uma parcela do imóvel deve ser informada.' : '' }));
        if (isEmpty) {
            handleValidateParcela();
        }
        return !isEmpty;
    }, [(_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _c === void 0 ? void 0 : _c.length, requerimentoFieldError]);
    var handleChange = useCallback(function (event) {
        var _a = event.target, name = _a.name, value = _a.value;
        setParcelaImovel(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    }, []);
    var handleChanges = useCallback(function (_parcelaImovelTeor, tipoImovel) {
        var _a, _b;
        setParcelaImovel(_parcelaImovelTeor);
        if ((tipoImovel !== null && tipoImovel !== void 0 ? tipoImovel : _parcelaImovelTeor.tipoImovel) === TipoImovelEnum.URBANO
            && ((_b = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, requerimento), { parcelasImovel: [_parcelaImovelTeor] }));
        }
    }, [requerimento, onChange, (_e = ((_d = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _d !== void 0 ? _d : [])) === null || _e === void 0 ? void 0 : _e.length]);
    var handleTipoChange = function (tipo) {
        if (isDisabledBySigef)
            setIsDisabledBySigef(false);
        setFieldError({});
        if (!isEdit) {
            setParcelaImovel(__assign(__assign({}, defaultParcela), { pecasTecnicas: tipo }));
        }
    };
    var validateParcela = function () {
        var _a, _b;
        var rt = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.responsavelTecnico;
        var isSigef = pecasTecnicas === TipoParcelaEnum.SIGEF;
        var isSnci = pecasTecnicas === TipoParcelaEnum.SNCI;
        var matriculaSelecionada = documentoSelecionado === 'matricula';
        var escrituraSelecionada = documentoSelecionado === 'escritura';
        var verificaDocs = !pecasIsSigef;
        var _parcelaErrorField = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], validateRtFields(rt), true), [
            { key: 'codigoSIGEFError', condition: isSigef && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoSIGEF), },
            { key: 'numeroCertificacaoError', condition: isSnci && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.numeroCertificacao) },
            {
                key: 'denominacaoError',
                condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.denominacao),
            },
            { key: 'areaError', condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area) },
            {
                key: 'codigoArtError',
                condition: isSigef && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.codigoArt),
            }
        ], false), (documentoSelecionado === 'titulo'
            ? [
                {
                    key: 'numeroTituloDefinitivoError',
                    condition: !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.numeroTituloDefinitivo),
                },
            ]
            : []), true), [
            {
                key: 'municipioAtualError',
                condition: !hasValue((_a = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.municipio) === null || _a === void 0 ? void 0 : _a.id),
            },
            {
                key: 'comarcaError',
                condition: isSnci && !hasValue((_b = parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.comarca) === null || _b === void 0 ? void 0 : _b.id),
            },
            {
                key: 'matriculaError',
                condition: verificaDocs && matriculaSelecionada && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.matricula),
            },
            {
                key: 'escrituraError',
                condition: isSnci && escrituraSelecionada && !hasValue(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.matricula),
            },
        ], false);
        return generateErrorFields(_parcelaErrorField, __assign({}, fieldError));
    };
    var handleValidateParcela = function () {
        var _parcelaFieldError = validateParcela();
        setFieldError(_parcelaFieldError);
        return !hasErrors(_parcelaFieldError);
    };
    var handleAdd = function () {
        defaultHandleAddParcelaImovel({
            indexSelecionadoState: [indexSelecionadoTeor, setIndexSelecionadoTeor],
            defaultBaseValue: __assign(__assign({}, defaultParcela), { pecasTecnicas: pecasTecnicas }),
            disableState: [isDisabledBySigef, setIsDisabledBySigef],
            valueState: [parcelaImovel, setParcelaImovel],
            fieldErrorState: [fieldError, setFieldError],
            requerimentoState: [requerimento, onChange],
            valido: handleValidateParcela(),
            modoState: [modo, setModo],
            sigefIsOnline: sigefIsOnline,
        });
    };
    var onHandleRemoveItem = useCallback(function (index) {
        var _a;
        if (onChange) {
            onChange(__assign(__assign({}, requerimento), { parcelasImovel: (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.filter(function (_, idx) { return idx !== index; }) }));
        }
    }, [requerimento, onChange]);
    var onHandleEdit = useCallback(function (index) {
        var _a, _b;
        if ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a[index]) {
            var parcela = requerimento.parcelasImovel[index];
            var modoParcela = ((_b = parcela === null || parcela === void 0 ? void 0 : parcela.pecasTecnicas) !== null && _b !== void 0 ? _b : TipoParcelaEnum.SIGEF);
            setPecasTecnicas(modoParcela);
            setParcelaImovel(__assign({}, parcela));
            setParcelaImovel(__assign({}, parcela));
            setModo(ModoCRUDEnum.UPDATE);
            setIndexSelecionadoTeor(index);
            setFieldError({});
            handleScrollTop();
        }
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel]);
    var table = useCallback(function () {
        var _a, _b;
        return (_jsx(StepContent, __assign({ show: true }, { children: _jsx(DefaultCard, __assign({ title: '' }, { children: _jsx(SimpleTable, { error: (((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a.length) === 0 ? ((_b = requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError) !== null && _b !== void 0 ? _b : '') : ''), indexMark: indexSelecionadoTeor !== null && indexSelecionadoTeor !== void 0 ? indexSelecionadoTeor : undefined, onHandleRemoveItem: onHandleRemoveItem, emptyText: "Nenhuma Parcela Inserida", setEditarIncluir: setEditarIncluir, onHandleEdit: onHandleEdit, showOptions: true, columns: columns, values: values }) })) })));
    }, [
        requerimentoFieldError === null || requerimentoFieldError === void 0 ? void 0 : requerimentoFieldError.parcelasImovelError,
        (_f = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _f === void 0 ? void 0 : _f.length,
        indexSelecionadoTeor,
        onHandleRemoveItem,
        onHandleEdit,
        columns,
        values,
    ]);
    var handleRadioChangedocumento = useCallback(function (value) {
        setParcelaImovel(function (prev) { return (__assign(__assign({}, prev), { documentoAquisicao: documentoMap[value] })); });
    }, []);
    var desabledFieldsSigef = useMemo(function () {
        var optIsOnline = (sigefIsOnline && !!(parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area) ? possuiRtSigef : true);
        return (pecasTecnicas === TipoParcelaEnum.SIGEF ? optIsOnline : false);
    }, [sigefIsOnline, parcelaImovel === null || parcelaImovel === void 0 ? void 0 : parcelaImovel.area, possuiRtSigef, pecasTecnicas]);
    var disabledFormSigef = useMemo(function () {
        return (pecasTecnicas === TipoParcelaEnum.SIGEF ? sigefIsOnline : false);
    }, [sigefIsOnline, pecasTecnicas]);
    var disabled = useMemo(function () {
        var _a, _b;
        return ((_b = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.length) > 0 || isEdit;
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel, (_h = ((_g = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.length, isEdit]);
    //endregion
    //region Handles
    var handleInitialize = function () {
        var _a, _b;
        var first = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) === null || _a === void 0 ? void 0 : _a[0];
        var tipo = (_b = first === null || first === void 0 ? void 0 : first.pecasTecnicas) !== null && _b !== void 0 ? _b : TipoParcelaEnum.SIGEF;
        setPecasTecnicas(tipo);
        setParcelaImovel(function (prev) { return (__assign(__assign({}, prev), { pecasTecnicas: tipo })); });
    };
    //endregion
    return (_jsxs(ParcelaImovelCadastro, __assign({ isView: modo === ModoCRUDEnum.VIEW, isDisabledBySigef: desabledFieldsSigef, setEditarIncluir: setEditarIncluir, onFieldErrorChange: setFieldError, parcelaImovel: parcelaImovel, onChange: setParcelaImovel, ocultarCampo: ocultarCampo, fieldError: fieldError, isEdit: editarIncluir, handleAdd: handleAdd, showBtnAdd: true, table: table() }, { children: [_jsx(DefaultCard, __assign({ title: "", style: { textAlign: 'left', padding: '32px' } }, { children: _jsx(CustomRadioGroup, { onChange: function (event) { return handleRadioChangedocumento(event.target.value); }, label: "Deseja utilizar qual documento?", value: documentoSelecionado, options: [
                        { value: 'titulo', label: 'Título' },
                        { value: 'matricula', label: 'Matrícula' },
                        { value: 'escritura', label: 'Escritura' },
                    ], name: "documento", required: true, collumn: true }) })), _jsx(DefaultCard, __assign({ title: "" }, { children: _jsx(DadosPecasTecParcela, { handleOnChangePecas: function (value) { return handleTipoChange(value); }, options: TipoParcelaEnum.getScniSigefOptions(), setPecasObject: setPecasTecnicas, pecasObject: pecasTecnicas, disabled: disabled }) })), _jsx(ShowContent, __assign({ show: pecasTecnicas === TipoParcelaEnum.SIGEF }, { children: _jsx(SessaoSIGEF, { sigefIsOnline: sigefIsOnline, setSigefIsOnline: setSigefIsOnline }) })), _jsxs(DefaultCard, __assign({ title: "Dados da Parcela", subTitle: subTitle }, { children: [_jsx(ShowContent, __assign({ show: pecasTecnicas === TipoParcelaEnum.SNCI }, { children: _jsx(ParcelaFormSNCI, { parcelaImovelTeor: parcelaImovel, setParcelaImovelTeor: setParcelaImovel, documentoSelecionado: documentoSelecionado, handleChanges: handleChanges, handleChange: handleChange, fieldError: fieldError }) })), _jsx(ShowContent, __assign({ show: pecasTecnicas === TipoParcelaEnum.SIGEF }, { children: _jsx(ParcelaFormSigef, { requerimentoFieldError: requerimentoFieldError, temRtSigef: [possuiRtSigef, setPossuiRtSigef], documentoSelecionado: documentoSelecionado, setParcelaImovel: setParcelaImovel, isDisabledBySigef: disabledFormSigef, setSigefIsOnline: setSigefIsOnline, parcelaImovel: parcelaImovel, cpfRequerente: cpfRequerente, cnpjRequerente: cnpjRequerente, isImovelRural: isImovelRural, handleChanges: handleChanges, sigefIsOnline: sigefIsOnline, handleChange: handleChange, pecasIsSigef: pecasIsSigef, fieldError: fieldError, requerimento: requerimento, showMatricula: false }) }))] }))] })));
};
